// Pure helpers for the park reason an admin types or dictates on an
// initiative (kanban cac323f9, 82f83abb). They live beside ParkControl.tsx
// rather than inside it because the frontend eslint config enforces
// react-refresh/only-export-components: a .tsx module may export only
// components, so shared constants and functions go in a sibling .ts file.

/** Server-side cap on a park reason; the API rejects longer reasons with 422. */
export const PARK_REASON_MAX = 300;

/** Fold the reason the way the server does; blank is a park with no reason. */
export function cleanReason(raw: string): string | null {
  const folded = raw.replace(/\s+/g, ' ').trim();
  return folded ? folded : null;
}

/** A spoken reason lands after whatever was typed, on the same line. */
export function appendSpokenReason(current: string, transcript: string): string {
  const spoken = transcript.replace(/\s+/g, ' ').trim();
  if (!spoken) return current;
  const base = current.replace(/\s+/g, ' ').trim();
  return (base ? `${base} ${spoken}` : spoken).slice(0, PARK_REASON_MAX);
}
